export var Urls = {
    EntityMetaData: "EntityMetaData",
    GetDynamicColumnsForEntities: "EntityMetaData/GetDynamicColumnsForEntities",
    GetMetaDataWithDynamicProperties: "EntityMetaData/GetMetaDataWithDynamicProperties",
    Queries: "Queries",
    QueriesAll: "Queries/all",
    EntityMetaDataOperators: "EntityMetaDataOperators"
};
